import React, { useState,useEffect,useMemo,useCallback } from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
//import ListItemAvatar from '@mui/material/ListItemAvatar';
import Divider from '@mui/material/Divider';
//import Badge from '@mui/material/Badge';
import BookIcon from '@mui/icons-material/Book';
import Hidden from '@mui/material/Hidden';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import TopSales from './TopSales';
import TopStars from './TopStars';
import TopFavs from './TopFavs';
import TopSalesList from './TopSalesList';
import TopFavsList from './TopFavsList';
import Title from './Title';
import Ajax from './Ajax';
import {Owner,Info} from './Inc';
import Loading from './Loading';


interface Props {
	owner:Owner,
}

const Top = (props:Props)=> {
	const classes = useStyles();
	const [states,setStates] = useState({
		months: ["","",""],
		sales: {},
		stars: {},
		favs: {},
		salesList: [],
		favsList: [],
		isLoading: true,
	});
	const [infos,setInfos] = useState([] as Info[]);

	const infos1 = useMemo( ()=>{
		if( !infos ){
			return (null);
		}
		return (
			<List style={{margin:'0',padding:'0'}}>
				{infos.map((info:Info,index:number)=>{
					if( index>2 ){
						return (null);
					}
					const key = "info"+index;
					const to = "/info/"+info.info_id;
					return (
						<ListItemButton key={key} style={{marginBottom:'1em',padding:'0'}} component={Link} to={to}>
							<ListItemText primary={<span className={classes.infoPrimary}>{info.title}</span>} secondary={<span className={classes.infoSecondary}>{info.publish_time}{info.new_flag &&
								<span className={classes.new} style={{marginLeft:'0.5em'}}>NEW!</span>
								}</span>}/>
						</ListItemButton>
					);
				})}
			</List>
		);
	}, [infos]);

	const infos2 = useMemo( ()=>{
		if( !infos ){
			return (null);
		}
		return (
			<List dense style={{margin:'0',padding:'0'}}>
				{infos.map((info:Info,index:number)=>{
					const key = "info"+index;
					const to = "/info/"+info.info_id;
					if( index<3 ){
						return (null);
					}
					return (
						<ListItem key={key} button style={{marginBottom:'1em',padding:'0'}} component={Link} to={to}>
							<ListItemText primary={<span className={classes.infoPrimary}>{info.title}</span>} secondary={<span className={classes.infoSecondary}>{info.publish_time}{info.new_flag &&
								<span className={classes.new} style={{marginLeft:'0.5em'}}>NEW!</span>
								}</span>}/>
						</ListItem>
					);
				})}
			</List>
		);
	}, [infos]);

	const getInfos = useCallback( ()=>{
		//console.log("getInfos");
		Ajax.send("top/infos",{},(res:any)=>{
			if( res.ok ){
				setInfos(res.infos);
			}
		});
	},[]);

	const update = ()=>{
		window.location.reload();
	}

	useEffect( ()=>{
		//console.log("top:effect",props.owner.owner_id,states.isLoading);
		window.scrollTo(0,0);

		if( props.owner.owner_id>0 ){
			//console.log("start",props.owner.owner_id);
			setStates({...states,"isLoading":true});
			Ajax.setEditorId(props.owner.owner_id);
			Ajax.send("top/get",{},(res:any)=>{
				//console.log("stop",props.owner.owner_id,res);
				if( res.ok ){
					setStates({
						months: res.months,
						sales: res.sales,
						stars: res.stars,
						favs: res.favs,
						salesList: res.sales_list,
						favsList: res.favs_list,
						isLoading: false,
					})
				} else {
					setStates({...states,"isLoading":false});
				}
			});
		} else {
			setStates({
				months: ["","",""],
				sales: {
					month0: 0,
					month1: 0,
					month2: 0,
					year: 0,
					su_month0: 0,
					su_month1: 0,
					su_month2: 0,
					su_year: 0,
				},
				stars: {
					all: 0,
					month0: 0,
					month1: 0,
					month2: 0,
				},
				favs: {
					all: 0,
					month0: 0,
					month1: 0,
					month2: 0,
				},
				salesList: [],
				favsList: [],
				isLoading: false,
			})
		}
		getInfos();
	},[props.owner.owner_id]);

	//console.log("top:render",states.isLoading);

	return (
		<div id="top">
			<div className={classes.root}>
                <Grid container spacing={2}>
					<Grid item xs={12} md={9}>
						<TopSales sales={states.sales} months={states.months}/>
						<TopSalesList list={states.salesList} owner={props.owner}/>
						<TopStars stars={states.stars} months={states.months}/>
						<TopFavs favs={states.favs} months={states.months}/>
						<TopFavsList list={states.favsList} owner={props.owner}/>
					</Grid>
					<Grid item xs={12} md={3}>
						{props.owner.owner_id===0 &&
						<Paper className={classes.paper} style={{marginBottom:"2em"}}>
							<Title text="はじめてのご利用" icon="store"/>
							<div style={{marginBottom:"2em"}}>
								ほとんどすべての機能を実際に試していただけます。はじめての作家さんは「ご利用ガイド」をご覧下さい。<br/>
							</div>
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<Link to="/first"><Button variant="contained" color="primary" style={{width:"100%"}} startIcon={<BookIcon/>}>ご利用ガイド</Button></Link>
							</FormControl>
						</Paper>
						}
						<Paper className={classes.paper}>
							<Title text="お知らせ"/>
							<div className="infoList" style={{paddingTop:"0"}}>
								{infos1}
								<Hidden mdDown implementation="js">
								{infos2}
								</Hidden>
							</div>
							<Divider/>
							<nav className={classes.more}>
								<Link to="/info" className={classes.link}><ArrowForwardIcon/>お知らせをもっと見る</Link>
							</nav>
						</Paper>
						<div className="sideb_version"><Button variant="text" endIcon={<BrowserUpdatedIcon/>} onClick={update}>ver.{process.env.REACT_APP_VERSION}</Button></div>
					</Grid>
				</Grid>
            </div>
			<Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default Top;
